import type { WidgetProps } from '@rjsf/utils'
import { Mtds } from 'prove-common'

export const TextareaWidget = ({
  disabled,
  id,
  onChange,
  placeholder,
  readonly,
  required,
  schema,
  uiSchema,
  value = ''
}: WidgetProps) => (
  <>
    <Mtds.Textarea
      disabled={disabled}
      id={id}
      maxLength={schema.maxLength}
      onChange={({ target }) => onChange(target.value)}
      placeholder={placeholder}
      readOnly={readonly}
      required={required}
      rows={uiSchema?.['ui:options']?.rows}
      value={value}
    />
    {!!schema.maxLength && (
      <Mtds.Validation data-field={'counter'} data-limit={schema.maxLength} />
    )}
  </>
)
